export enum TaskType {
    UPLOAD,
    DOWNLOAD,
    DELETE,
    PERMANENT_DELETE,
    RESTORE,
    REMOVE_IMAGE_BACKGROUND,
}
